import { ReceptionServiceForPractitionerSimple } from '@dreryk/egabinet-private-medical-service-frontend-api';
import { AppointmentReceptionService } from '@dreryk/egabinet-appointment-frontend-api';

export const mapReceptionServiceForPractitionerSimpleToAppointmentReceptionService = (
   receptionServiceForPractitionerSimple: ReceptionServiceForPractitionerSimple
): AppointmentReceptionService => {
   return {
      receptionServiceId: receptionServiceForPractitionerSimple.receptionServiceId.asNumber(),
      name: receptionServiceForPractitionerSimple.name,
      color: receptionServiceForPractitionerSimple.color,
      minPrice: receptionServiceForPractitionerSimple.minPrice,
      maxPrice: receptionServiceForPractitionerSimple.maxPrice,
      advancePaymentValue: receptionServiceForPractitionerSimple.advancePaymentValue,
      additionalInformation: receptionServiceForPractitionerSimple.additionalInformation,
      estimatedDuration: receptionServiceForPractitionerSimple.estimatedDuration,
      deliveryMode: receptionServiceForPractitionerSimple.deliveryMode,
      serviceLocationIds: receptionServiceForPractitionerSimple.serviceLocationIds,
   };
};
